<script lang="tsx">
import { defineComponent, type PropType } from 'vue'
import MultipleDefaultSelect from '../../../selects/default-select-multiple'
import { MultipleDefaultSelectFilter } from '../../Filters'

export default defineComponent({
  props: {
    filter: {
      type: Object as PropType<MultipleDefaultSelectFilter>,
      required: true,
    },
  },
  setup(props) {
    const setValue = (val: Array<{ id: string, name: string }>) => {
      console.log(val)
      props.filter.addValue(val)
    }

    return () => (

      <div class="ark-ui-filterbar-default-select-multiple-filter">
        <MultipleDefaultSelect
          items={props.filter.options}
          placeholder={props.filter.label}
          modelValue={props.filter.value}
          onValueChange={setValue}
          showItemsCount={5}
        />
      </div>

    )
  },
})
</script>

<style lang="scss" scoped>
</style>
